import { render, staticRenderFns } from "./number-range.vue?vue&type=template&id=6bbc2fdc"
import script from "./number-range.vue?vue&type=script&lang=ts"
export * from "./number-range.vue?vue&type=script&lang=ts"
import style0 from "./number-range.vue?vue&type=style&index=0&id=6bbc2fdc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports